import { COMMUNITY_IMAGE_WIDTH } from '@shared/dream-components';

import type { PostMediaImage } from '~/routes/community/_components/ui/PostMediaFrame';

import { communityImageSrc } from './communityImageSrc';

const ZOOM_WIDTH = 2600;

export const toPostMediaImage = (src: string, alt: string, id = src): PostMediaImage => ({
  id,
  alt,
  src: communityImageSrc(src, COMMUNITY_IMAGE_WIDTH),
  fullSrc: communityImageSrc(src, ZOOM_WIDTH),
});
